module.exports = __webpack_public_path__ + "img/enterprise2.31226f03.png";